exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-order-confirm .vux-number-selector {\n  font-size: 18px;\n}\n.page-order-confirm .vux-number-selector svg {\n  fill: #333;\n}\n", ""]);

// exports
